import React, { useEffect, useState } from 'react'
import { Modal, Button } from "react-bootstrap";
import { Avatar } from '../../../base/avatar';
import { SendAlert } from "./AlertChat";
import {InviteViaMail} from "./actions";
import { meetingURL } from '../../common';

function InviteMember({ show, handleClose, extension_list, room_name, topic,meet_type,SendInvitationList,meeting_code }) {
    const [memberList, setMemberList] = useState([]);
    const [member, setMember] = useState([]);
    const [search, setSearch] = useState("");
    const [clicked, setClicked] = useState(false);

    useEffect(() => {
        $(".member-invitee").draggable({
            handle: ".member-key",
            containment: "#InviteMember",
        });
    }, []);

    useEffect(() => {
        if (extension_list) {
            setMemberList(extension_list);
        }
    }, [extension_list])

    useEffect(() => {
        if (search !== "") {
            setMemberList(extension_list.filter(value => value.firstname.toLowerCase().includes(search.toLowerCase())))
        } else {
            setMemberList(extension_list);
        }
    }, [search])

    const SendInvitation = async() => {
        setClicked(true);
        member.map(value => {
            const { firstname, lastname, app_picture, phone, uniquecode } = value;
            SendAlert({ name: `${firstname} ${lastname}`, app_picture, phone, uniquecode, message: room_name, media: topic,meet_type });
        })
        let response = await APP.store.dispatch(InviteViaMail({ 
            email:member.map(value=>value.email), 
            meeting_code, 
            link: meetingURL() 
        }))
        if(response===1){            
            SendInvitationList({meeting_code});
            handleClose();
            setMember([]);
            setClicked(false);
        } 
    }
    return (
        <Modal
            id="InviteMember"
            dialogClassName="modal-sm device-setting-invite-via-member"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            contentClassName="InviteViaMember-content"
        >
            <Modal.Body className="member-invitee invite-modal-body-outer">
                <div className="invite-modal-body-inner member-key">
                    <div className="head-member-invite">
                        <h3>Invite Team Member to meeting room
                            <button type="button" className="close">
                                <span aria-hidden="true" onClick={handleClose}>
                                    <img src="public/assets/images/invite-cross.svg" alt="1" />
                                </span>
                            </button>
                        </h3>
                    </div>
                    {/* <div className="dail-pad-member-invite">
                        <a><img src="public/assets/images/dail-orange-ico.svg" alt="1"/>Dial Pad</a>
                    </div> */}
                    <div className="selected-member">
                        {member.map((value, keys) => {
                            return (
                                <span className="select-member-img" key={`profile${keys}`}>
                                    <Avatar
                                        displayName={value.firstname}
                                        size={48}
                                        testId='knockingParticipant.avatar'
                                        url={value.profile_picture}
                                    />
                                    <span onClick={() => { member.filter(val => val.uniquecode === value.uniquecode).length ? setMember(member.filter(val => val.uniquecode != value.uniquecode)) : setMember([...member, value]) }}>
                                        <img src="public/assets/images/cross-orange-circle.svg" alt="1" />
                                    </span>
                                </span>
                            )
                        })}
                    </div>
                    <div className="share-meeting-link">
                        <span> <img src="public/assets/images/upload-ico-invite-member.svg" alt="1" /></span>
                        <input type="text" name="search" value={search} placeholder="Share meeting link  to join meeting" className="form-control" onChange={e => setSearch(e.target.value)} />
                    </div>
                    <div className="invite-via-member-list-div">
                        <h3>Select Team Members</h3>
                        {memberList && memberList.map((value, key) => {
                            return (
                                <div className="invite-via-member-list" key={`members${key}`}>
                                    <div className="invite-member-name">
                                        <span>
                                            <Avatar
                                                displayName={value.firstname}
                                                size={48}
                                                testId='knockingParticipant.avatar'
                                                url={value.profile_picture}
                                            />
                                            {/* <i className="fas fa-circle text-success"></i> */}
                                        </span>
                                        <h5>{value.firstname}</h5>
                                    </div>
                                    <div className={`select-member-span ${member.filter(val => val.uniquecode === value.uniquecode).length ? "active" : ""}`} onClick={() => { member.filter(val => val.uniquecode === value.uniquecode).length ? setMember(member.filter(val => val.uniquecode != value.uniquecode)) : setMember([...member, value]) }}>
                                        <img src="public/assets/images/tick-assign.svg" alt="1" />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="invite-via-member-footer-div">
                        <a href={void 0} onClick={SendInvitation}>{clicked?"Please Wait...":"Add to meeting"}</a>
                    </div>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary">Understood</Button>
            </Modal.Footer> */}
        </Modal>
    )
}

export default InviteMember
